module.exports = __webpack_public_path__ + "img/issueNone.f4522654.png";